import React, {CSSProperties, useEffect, useState} from 'react';
import { Row, Col, Card, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

const MemberDetailsCard: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const claimDetails: any = useSelector(
    (state: RootState) => state?.claimsDetails?.claimDetails,
  );

  const cardHeaderStyle: CSSProperties = {
    background: '#E9ECF0',
    color: 'black',
    padding: '12px',
    textAlign: 'center',
  };

  useEffect(() => {
    // creating a delay
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <div style={{width: '80vw', paddingLeft: '70px'}}>
      <Spin spinning = {loading}>
      <Card title = "Member Details" headStyle={cardHeaderStyle}>
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <label>Patient Name</label>
            <div>{claimDetails.patientName}</div>
          </Col>
          <Col span={6}>
            <label>Mobile No.</label>
            <div>{claimDetails.patientMobileNo}</div>
          </Col>
          <Col span={4}>
            <label>Email Id</label>
            <div>{claimDetails.email}</div>
          </Col>
          <Col span={4}>
            <label>Member Id</label>
            <div>{claimDetails.memberId}</div>
          </Col>
          <Col span={4}>
            <label>Corporate Name</label>
            <div>{claimDetails.corporateName}</div>
          </Col>
        </Row>
        <br />
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <label>Employee Id</label>
            <div>{claimDetails.employeeId}</div>
          </Col>
          <Col span={6}>
            <label>Corporate Name</label>
            <div>{claimDetails.corporateName}</div>
          </Col>
          <Col span={4}>
            <label>Insurer Name</label>
            <div>{claimDetails.insuranceCompany}</div>
          </Col>
          <Col span={4}>
            <label>Payer/Tpa</label>
            <div>{claimDetails.payerName}</div>
          </Col>
          <Col span={4}>
            <label>Policy No</label>
            <div>{claimDetails.policyNo}</div>
          </Col>
        </Row>
        <br />
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <label>Inpatient No</label>
            <div>{claimDetails.inPatientNo}</div>
          </Col>
          <Col span={6}>
            <label>Date of Birth</label>
            <div>{claimDetails.dateOfBirth}</div>
          </Col>
          <Col span={4}>
            <label>Age</label>
            <div>{claimDetails.patientAge}</div>
          </Col>
          <Col span={4}>
            <label>Gender</label>
            <div>{claimDetails.patientGender}</div>
          </Col>
          <Col span={4}>
            <label>Relationship</label>
            <div>{}</div>
          </Col>
          <Col span={4}>
            <label>Hospital No.</label>
            <div>{claimDetails.hospitalNumber}</div>
          </Col>
        </Row>
      </Card>
      </Spin>
    </div>
  );
};

export default MemberDetailsCard;
